import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

const BOTCustomSchemas = ({ schemas }) =>
  <Helmet>
    <script type="application/ld+json">
      {schemas}
    </script>
  </Helmet>

BOTCustomSchemas.propTypes = {
  schemas: PropTypes.string
}

export default BOTCustomSchemas
